jQuery(document).ready(function ($) {
  if ($('.load-more').length > 0) {
    function setUniqClass(item) {
      if (item) {
        $.each(item, function () {
          $(this).each(function (index) {
            $(this).attr('class', `${$(this).attr('class')}-${index}`);
          });
        });
      }
    }

    let buttons = $('.load-more'),
        page = [],
        max_pages = [],
        per_page = [],
        sort_criteria = [],
        ids = [],
        show_title = [],
        show_rating = [],
        item_class = [];

    setUniqClass([$('.per-page'), $('.sort-criteria'), $('.ids'), $('.show-title'), $('.show-rating'), $('.item-class')]);

    buttons.each(function (index) {
      page[index] = $(this).data('page');
      max_pages[index] = $(this).data('max-pages');
      per_page[index] = $(`.per-page-${index}`).val();
      sort_criteria[index] = $(`.sort-criteria-${index}`).val();
      ids[index] = $(`.ids-${index}`).val();
      show_title[index] = $(`.show-title-${index}`).val();
      show_rating[index] = $(`.show-rating-${index}`).val();
      item_class[index] = $(`.item-class-${index}`).val();
    });

    buttons.each(function (index) {
      $(this).on('click', function (event) {
        event.preventDefault();
        let _this = $(this);

        $.ajax({
          method: 'POST',
          url: slot_reviews.url,
          data: {
            nonce: slot_reviews.nonce,
            page: page[index],
            per_page: per_page[index],
            sort_criteria: sort_criteria[index],
            ids: ids[index],
            show_title: show_title[index],
            show_rating: show_rating[index],
            item_class: item_class[index],
            action: 'more_slots'
          },
          beforeSend: function () {
            _this.prop('disabled', true);
          },
          success: function (responce) {
            page[index]++;
            _this.parent().find('.row').append(responce);
            if (page[index] === max_pages[index]) {
              _this.remove();
            }
            _this.prop('disabled', false);
          }
        });
      });
    });
  }
});
